<template>
  <v-sheet
    elevation="2"
    class="d-flex flex-column justify-center align-center px-6 py-15"
    rounded
  >
    <div>
      <LoaderSpinner v-if="isLoading" />
      <v-row v-else>
        <v-col sm="6" offset-sm="3" xs="8" offset-xs="2">
          <v-img
            class="mx-10 mt-6 mb-5"
            :src="imageSource"
            alt="empty state image"
          />
          <p class="h6 grey--text text--darken-2 font-bold mb-2 text-center">
            {{ title }}
          </p>
          <p class="body-1 grey--text text--darken-2 mb-6 text-center">
            {{ subtitle }}
          </p>
          <slot name="actions"> </slot>
        </v-col>
      </v-row>
    </div>
  </v-sheet>
</template>

<script>
import LoaderSpinner from './LoaderSpinner.vue'
import emptyImage from '@/assets/images/empty-states/empty-state-revs.png'

export default {
  name: 'EmptyPageStateManager',

  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    imageSource: {
      default: emptyImage,
      type: String,
      required: false,
    },
    title: {
      default: '',
    },
    subtitle: {
      required: false,
    },
  },

  components: {
    LoaderSpinner: LoaderSpinner,
  },
}
</script>
